import styled from 'styled-components';

import AttachIcon from '@yourcoach/shared/assets/icons/attach.svg';
import {FilesListItem} from '@yourcoach/shared/components/FilesListItem';
import {ms} from '@yourcoach/shared/styles/normalizeSize';
import {getColor} from '@yourcoach/shared/styles/utils';
import {Button} from '@yourcoach/shared/uikit/Button';
import {View} from '@yourcoach/shared/uikit/View';

export const AddAttachmentsButton = styled(Button).attrs({
  scheme: 'gray',
})``;

export const AddAttachmentsButtonIcon = styled(AttachIcon)`
  width: ${ms(20)};
  height: ${ms(20)};
  fill: ${getColor('icon3')};
  margin-right: ${ms(8)};
`;

export const AttachmentsList = styled(View)`
  gap: ${ms(20)};
  display: grid;
  grid-template-columns: repeat(auto-fill, calc(50% - 10px));
  margin-bottom: ${ms(20)};
`;

export const AttachmentsListItem = styled(FilesListItem)`
  border: 1px solid ${getColor('border2')};
  padding: ${ms(8)};
  border-radius: ${ms(10)};
  flex: 1;
`;

export const StopDateToggleContainer = styled(View)`
  position: relative;
  top: ${ms(-3)};
`;
